import { format, parseISO, startOfWeek, endOfWeek, startOfMonth, endOfMonth } from 'date-fns';

// Символы валют
const currencySymbols: Record<string, string> = {
  'RUB': '₽',
  'USD': '$',
  'EUR': '€',
  'GBP': '£',
  'JPY': '¥',
  'CNY': '¥',
  'KZT': '₸',
  'UAH': '₴',
  'BYN': 'Br',
  'TRY': '₺',
  'INR': '₹',
  'BRL': 'R$',
  'AUD': 'A$',
  'CAD': 'C$',
  'CHF': 'CHF',
  'SEK': 'kr',
  'NOK': 'kr',
  'DKK': 'kr',
  'PLN': 'zł',
  'CZK': 'Kč',
  'HUF': 'Ft',
  'RON': 'lei',
  'BGN': 'лв',
  'HRK': 'kn',
  'RSD': 'дин',
  'AED': 'د.إ',
  'SAR': '﷼',
  'QAR': '﷼',
  'KWD': 'د.ك',
  'ILS': '₪',
  'EGP': 'E£',
  'ZAR': 'R',
  'NGN': '₦',
  'KES': 'KSh',
  'GHS': '₵',
  'MXN': '$',
  'ARS': '$',
  'CLP': '$',
  'COP': '$',
  'PEN': 'S/',
  'VES': 'Bs.',
  'UYU': '$U',
  'KRW': '₩',
  'SGD': 'S$',
  'HKD': 'HK$',
  'TWD': 'NT$',
  'THB': '฿',
  'MYR': 'RM',
  'IDR': 'Rp',
  'PHP': '₱',
  'VND': '₫',
  'PKR': '₨',
  'BDT': '৳',
  'LKR': 'Rs',
  'NPR': 'Rs',
  'MMK': 'K',
  'KHR': '៛',
  'LAK': '₭',
  'GEL': '₾',
  'AMD': '֏',
  'AZN': '₼',
  'UZS': "so'm",
  'KGS': 'с',
  'TJS': 'ЅМ',
  'TMT': 'm',
  'MDL': 'L',
  'NZD': 'NZ$',
  'ISK': 'kr',
  'XTR': 'XTR',
};

// Маппинг валюты на локаль для правильного форматирования
const currencyLocales: Record<string, string> = {
  // Русскоязычные страны - запятая как десятичный разделитель
  'RUB': 'ru-RU',  // 1 000,50 ₽
  'BYN': 'ru-BY',  // 1 000,50 Br
  'KZT': 'ru-KZ',  // 1 000,50 ₸
  'UAH': 'uk-UA',  // 1 000,50 ₴
  'UZS': 'uz-UZ',  // 1 000,50 so'm
  'KGS': 'ky-KG',  // 1 000,50 с
  'TJS': 'tg-TJ',  // 1 000,50 ЅМ
  'AZN': 'az-AZ',  // 1.000,50 ₼
  'AMD': 'hy-AM',  // 1 000,50 ֏
  'GEL': 'ka-GE',  // 1 000,50 ₾
  'MDL': 'ro-MD',  // 1.000,50 L
  
  // Англоязычные страны - точка как десятичный разделитель
  'USD': 'en-US',  // 1,000.50 $
  'GBP': 'en-GB',  // 1,000.50 £
  'AUD': 'en-AU',  // 1,000.50 A$
  'CAD': 'en-CA',  // 1,000.50 C$
  'NZD': 'en-NZ',  // 1,000.50 NZ$
  'SGD': 'en-SG',  // 1,000.50 S$
  'HKD': 'en-HK',  // 1,000.50 HK$
  'ZAR': 'en-ZA',  // 1 000,50 R
  'NGN': 'en-NG',  // 1,000.50 ₦
  'KES': 'en-KE',  // 1,000.50 KSh
  'GHS': 'en-GH',  // 1,000.50 ₵
  'INR': 'en-IN',  // 1,00,000.50 ₹ (индийская система)
  'PKR': 'en-PK',  // 1,000.50 ₨
  'BDT': 'en-BD',  // 1,000.50 ৳
  'LKR': 'en-LK',  // 1,000.50 Rs
  'NPR': 'en-NP',  // 1,000.50 Rs
  
  // Европа - запятая как десятичный разделитель
  'EUR': 'de-DE',  // 1.000,50 € (немецкий стандарт)
  'CHF': 'de-CH',  // 1'000.50 CHF
  'SEK': 'sv-SE',  // 1 000,50 kr
  'NOK': 'nb-NO',  // 1 000,50 kr
  'DKK': 'da-DK',  // 1.000,50 kr
  'ISK': 'is-IS',  // 1.000,50 kr
  'PLN': 'pl-PL',  // 1 000,50 zł
  'CZK': 'cs-CZ',  // 1 000,50 Kč
  'HUF': 'hu-HU',  // 1 000,50 Ft
  'RON': 'ro-RO',  // 1.000,50 lei
  'BGN': 'bg-BG',  // 1 000,50 лв
  'HRK': 'hr-HR',  // 1.000,50 kn
  'RSD': 'sr-RS',  // 1.000,50 дин
  
  // Азия
  'JPY': 'ja-JP',  // 1,000 ¥ (без копеек)
  'CNY': 'zh-CN',  // 1,000.50 ¥
  'KRW': 'ko-KR',  // 1,000 ₩ (без копеек)
  'TWD': 'zh-TW',  // 1,000.50 NT$
  'THB': 'th-TH',  // 1,000.50 ฿
  'MYR': 'ms-MY',  // 1,000.50 RM
  'IDR': 'id-ID',  // 1.000,50 Rp
  'PHP': 'fil-PH', // 1,000.50 ₱
  'VND': 'vi-VN',  // 1.000,50 ₫
  'MMK': 'my-MM',  // 1,000.50 K
  'KHR': 'km-KH',  // 1,000.50 ៛
  'LAK': 'lo-LA',  // 1,000.50 ₭
  
  // Ближний Восток
  'TRY': 'tr-TR',  // 1.000,50 ₺
  'AED': 'ar-AE',  // 1,000.50 د.إ
  'SAR': 'ar-SA',  // 1,000.50 ﷼
  'QAR': 'ar-QA',  // 1,000.50 ﷼
  'KWD': 'ar-KW',  // 1,000.500 د.ك (3 знака после запятой!)
  'ILS': 'he-IL',  // 1,000.50 ₪
  'EGP': 'ar-EG',  // 1,000.50 E£
  
  // Латинская Америка
  'BRL': 'pt-BR',  // 1.000,50 R$
  'MXN': 'es-MX',  // 1,000.50 $
  'ARS': 'es-AR',  // 1.000,50 $
  'CLP': 'es-CL',  // 1.000 $ (без копеек)
  'COP': 'es-CO',  // 1.000,50 $
  'PEN': 'es-PE',  // 1,000.50 S/
  'UYU': 'es-UY',  // 1.000,50 $U
  'VES': 'es-VE',  // 1.000,50 Bs.
  
  // Другие
  'XTR': 'en-US',  // Telegram Stars
  'TMT': 'tk-TM',  // 1 000,50 m
};

export const getCurrencySymbol = (currency: string = 'RUB'): string => {
  return currencySymbols[currency] || currency;
};

/**
 * Получает локаль для конкретной валюты
 */
const getCurrencyLocale = (currency: string): string => {
  return currencyLocales[currency] || 'en-US'; // fallback на английскую локаль
};

/**
 * Форматирует сумму с учетом правил конкретной валюты
 * Автоматически использует правильные разделители и позицию символа
 */
export const formatCurrency = (amount: number, currency: string = 'RUB', compact: boolean = false): string => {
  // Защита от некорректных данных
  const validAmount = typeof amount === 'number' && !isNaN(amount) ? amount : 0;
  
  try {
    // Компактный формат для графиков
    if (compact) {
      if (validAmount >= 1000000) {
        return `${(validAmount / 1000000).toFixed(1)}M`;
      } else if (validAmount >= 1000) {
        return `${(validAmount / 1000).toFixed(1)}K`;
      }
      return validAmount.toFixed(0);
    }
    
    // Получаем правильную локаль для валюты
    const locale = getCurrencyLocale(currency);
    
    // Определяем количество знаков после запятой
    // Для некоторых валют копейки не используются
    const noCentseCurrencies = ['JPY', 'KRW', 'CLP', 'VND', 'IDR'];
    const minFractionDigits = noCentseCurrencies.includes(currency) ? 0 : 0;
    const maxFractionDigits = noCentseCurrencies.includes(currency) ? 0 : 2;
    
    // KWD использует 3 знака после запятой
    const finalMaxFractionDigits = currency === 'KWD' ? 3 : maxFractionDigits;
    
    // Форматируем число с учетом локали
    const formattedNumber = new Intl.NumberFormat(locale, {
      minimumFractionDigits: minFractionDigits,
      maximumFractionDigits: finalMaxFractionDigits,
    }).format(validAmount);
    
    // Получаем символ валюты
    const symbol = getCurrencySymbol(currency);
    
    // Определяем позицию символа валюты
    // Для большинства западных валют символ идет перед числом
    const symbolsBeforeAmount = ['$', '£', '€', 'CHF', 'A$', 'C$', 'NZ$', 'HK$', 'S$', 'NT$', 'R$', '$U', 'E£'];
    if (symbolsBeforeAmount.includes(symbol)) {
      // Если число отрицательное, ставим минус перед символом валюты
      if (validAmount < 0) {
        const absoluteFormatted = new Intl.NumberFormat(locale, {
          minimumFractionDigits: minFractionDigits,
          maximumFractionDigits: finalMaxFractionDigits,
        }).format(Math.abs(validAmount));
        return `-${symbol}${absoluteFormatted}`;
      }
      return `${symbol}${formattedNumber}`;
    }
    
    // Для остальных валют символ идет после числа
    return `${formattedNumber} ${symbol}`;
  } catch (error) {
    console.error('❌ formatCurrency error:', error, { amount, validAmount, currency });
    // Если не удалось отформатировать, возвращаем простое число
    const symbol = getCurrencySymbol(currency);
    return `${validAmount.toFixed(2)} ${symbol}`;
  }
};

export const formatDate = (dateString: string, formatStr: string = 'd MMM yyyy'): string => {
  try {
    const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
    return format(date, formatStr);
  } catch {
    return dateString;
  }
};

export const formatDateShort = (dateString: string): string => {
  return formatDate(dateString, 'd MMM');
};

export const formatDateLong = (dateString: string): string => {
  return formatDate(dateString, 'd MMMM yyyy');
};

export const formatTime = (dateString: string): string => {
  try {
    const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
    return format(date, 'HH:mm');
  } catch {
    return '';
  }
};

export const formatTimeAMPM = (dateString: string): string => {
  try {
    const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
    return format(date, 'h:mm a'); // 12-часовой формат с AM/PM
  } catch {
    return '';
  }
};

export const formatDateWithTime = (dateString: string): string => {
  try {
    // Парсим дату - parseISO корректно обрабатывает UTC даты с Z на конце
    const date = typeof dateString === 'string' ? parseISO(dateString) : dateString;
    // format автоматически конвертирует в локальную таймзону браузера
    // Используем 'd MMM, HH:mm' для отображения в 24-часовом формате
    return format(date, 'd MMM, HH:mm'); // "6 Oct, 11:26"
  } catch (error) {
    console.error('Error formatting date:', error, 'Input:', dateString);
    return dateString;
  }
};

export const getPeriodDates = (period: string): { start: Date; end: Date } => {
  const today = new Date();
  
  switch (period) {
    case 'today':
      return {
        start: new Date(today.setHours(0, 0, 0, 0)),
        end: new Date(today.setHours(23, 59, 59, 999)),
      };
      
    case 'week':
      return {
        start: startOfWeek(today, { weekStartsOn: 1 }),
        end: endOfWeek(today, { weekStartsOn: 1 }),
      };
      
    case 'month':
      return {
        start: startOfMonth(today),
        end: endOfMonth(today),
      };
      
    case 'year':
      return {
        start: new Date(today.getFullYear(), 0, 1),
        end: new Date(today.getFullYear(), 11, 31, 23, 59, 59),
      };
      
    default:
      return {
        start: startOfMonth(today),
        end: endOfMonth(today),
      };
  }
};

export const formatPeriodLabel = (period: string, startDate?: Date, endDate?: Date): string => {
  if (period === 'custom' && startDate && endDate) {
    return `${formatDateShort(startDate.toISOString())} - ${formatDateShort(endDate.toISOString())}`;
  }
  
  const labels: Record<string, string> = {
    today: 'Сегодня',
    week: 'Эта неделя',
    month: 'Этот месяц',
    year: 'Этот год',
  };
  
  return labels[period] || labels.month;
};

export const getGreeting = (): string => {
  const hour = new Date().getHours();
  if (hour < 6) return 'night';
  if (hour < 12) return 'morning';
  if (hour < 18) return 'afternoon';
  return 'evening';
};

export const getDaysUntil = (dateString: string): number => {
  const target = parseISO(dateString);
  const today = new Date();
  const diffTime = target.getTime() - today.getTime();
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};

export const getRelativeTime = (dateString: string): string => {
  const date = parseISO(dateString);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'только что';
  if (diffMins < 60) return `${diffMins} мин назад`;
  if (diffHours < 24) return `${diffHours} ч назад`;
  if (diffDays < 7) return `${diffDays} дн назад`;
  
  return formatDateShort(dateString);
};

// Удаление эмодзи и символов-пиктограмм из строки
export const stripEmojis = (text: string): string => {
  if (!text) return text;
  try {
    // Unicode диапазоны эмодзи и пиктограмм
    const emojiRegex = /[\p{Extended_Pictographic}\u2600-\u27BF]/gu;
    return text.replace(emojiRegex, '').replace(/\s{2,}/g, ' ').trim();
  } catch {
    return text;
  }
};

// Словарь для локализации категорий
const categoryTranslations: Record<string, string> = {
  'expense': 'Расход',
  'income': 'Доход',
  'Expense': 'Расход',
  'Income': 'Доход',
};

// Локализация названия категории
export const localizeCategory = (category: string): string => {
  if (!category) return '';
  // Если категория есть в словаре - возвращаем перевод
  if (categoryTranslations[category]) {
    return categoryTranslations[category];
  }
  // Иначе возвращаем как есть (это может быть кастомная категория)
  return category;
};

